import gql from 'graphql-tag'

import { ProfileMediaFieldsFragment } from './profileMedia'

export { ProfileFields as IProfile } from './__generated__/ProfileFields'

export const ProfileFieldsFragment = gql`
  fragment ProfileFields on Profile {
    id
    ageMonthsMax
    ageMonthsMin
    daysOfWeek
    enrollment
    hoursStart
    hoursEnd
    networkRating
    philosophy
    philosophySecondary
    subsidizedCareAccepted
    tagline
    primaryProfileMedia: profileMedia(onlyPrimary: true) {
      ...ProfileMediaFields
    }
    whitelabelRating {
      label
      slug
      symbolCount
    }
    externalLicenseUrl
    spokenLanguages
    subsidies {
      id
      name
    }
  }
  ${ProfileMediaFieldsFragment}
`
